import React from 'react'
import Layout from '@/components/shared/Layout'
import Head from 'next/head'
import ProgramDetailHero from '@/components/programs/ProgramDetailHero'
import ContactForm from '@/components/shared/ContactForm'
import WhomIsItFor from '@/components/programs/WhomIsItFor'
import ProgramStatistics from '@/components/programs/ProgramStatistics'
import CheckSyllabus from '@/components/programs/CheckSyllabus'
import OurGraduates from '@/components/programs/OurGraduates'
import { useTranslation } from 'next-i18next'
import { META_IMAGE, SITE_URL } from "@/utils/meta";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import ScrollAnimation from '@/components/shared/ScrollAnimation'
import ScholarshipCard from '@/components/shared/ScholarshipCard'
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale, params }) {
  const { program } = params

  const validPrograms = ['front-end', 'back-end', 'full-stack', 'software-engineering', 'summer-bootcamp']
  if (!validPrograms.includes(program)) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      program,
      ...(await serverSideTranslations(locale || "az")),
    },
  }
}

const ProgramDetail = ({ program }) => {
  const { t, i18n } = useTranslation();
  const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/programs/${program}`;
  return (
    <Layout>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{t(`programs-page.meta-title-${program}`)}</title>
        <meta name="keywords" content={program === "front-end" ? "suni intellekt, front-end muhendisi" : program === "back-end" ? "Artificial Intelligence, Back-End Engineer" : program === "full-stack" ? "Full-Stack Engineer" : "Software Engineering"} />
        <meta name="description" content={t(`programs-page.meta-description-${program}`)} />
        <meta name="image" content={META_IMAGE} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:site_name" content="peerstack.tech" />
        <meta property="og:title" content={t(`programs-page.meta-title-${program}`)} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:description" content={t(`programs-page.meta-description-${program}`)} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={META_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t(`programs-page.meta-title-${program}`)} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:description" content={t(`programs-page.meta-description-${program}`)} />
        <meta name="twitter:image" content={META_IMAGE} />
      </Head>
      <ProgramDetailHero programType={program} />
      <ScrollAnimation delay={100}>
        <ScholarshipCard programType={program} />
      </ScrollAnimation>
      <ScrollAnimation delay={100}>
        <WhomIsItFor currentProgram={program} />
      </ScrollAnimation>
      <ScrollAnimation delay={100}>
        <ProgramStatistics />
      </ScrollAnimation>
      <ScrollAnimation delay={100}>
        <OurGraduates program={program} />
      </ScrollAnimation>
      <ScrollAnimation delay={100}>
        <CheckSyllabus program={program} />
      </ScrollAnimation>
      <ContactForm />
      <ScrollToTopButton />
      <WhatsappButton />
    </Layout>
  )
}

export default ProgramDetail
